var map = {
	"./tips.png": 70878,
	"./tips10.png": 55433,
	"./tips11.png": 60957,
	"./tips12.png": 90915,
	"./tips2.png": 22871,
	"./tips3.png": 3729,
	"./tips4.png": 66949,
	"./tips5.png": 96577,
	"./tips6.png": 32372,
	"./tips7.png": 85191,
	"./tips8.png": 13129,
	"./tips9.png": 26291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96417;